var geolocationHelper = require('./geolocationHelper');

/**
 * Set the default location of the user.
 * @param {boolean} preventRedirect - If is prevent redirect to the page.
 * @returns {void} - The function does not return anything, but it sets the default location of the user.
 * @throws {Error} - The error is thrown if the request fails.
 */
function setDefaultLocation(preventRedirect) {
    let defaultLocation = $(".location-con").data("default-location");
    if (typeof defaultLocation === 'string') {
        defaultLocation = JSON.parse(defaultLocation);
    }
    if (!defaultLocation) {
        return;
    }
    defaultLocation.CONFIRM_LOCATION = false;
    let url = $(".confirm-location").first().data("url");
    let estado = defaultLocation.ESTADO;
    let municipio = defaultLocation.MUNICIPIO;
    let almacen = defaultLocation.ALMACEN_ID;

    $.ajax({
        url: url,
        method: 'Get',
        data: {'almacen': almacen, 'estado': estado,'municipio': municipio},
        async: true,
        success: function (data) {
            let selectedLocationCookie = {
                'ALMACEN_ID': almacen,
                'ESTADO': estado,
                'NOMBRE': municipio,
                'CONFIRM_LOCATION': false,
                'DEFAULT': true,
                'SUCURSAL_ID': data.sucursal
            }
            document.cookie = 'dataUserObtenerMunicipios=' + encodeURIComponent(JSON.stringify(selectedLocationCookie)) + '; expires=Wed, 1 Jan 2070 13:47:11 UTC; path=/';
            const pageAccessedByReload = sessionStorage.getItem("is_reloaded");
            if (preventRedirect) {
                return;
            }
            if (!pageAccessedByReload) {
                sessionStorage.setItem("is_reloaded", true);
                window.location.reload(true);
            } else {
                sessionStorage.removeItem("is_reloaded");
            }
        }
    });
}

/**
 * Set the location of the user.
 * @param {string} url - The URL of the server.
 * @param {string} almacen - The warehouse of the user.
 * @param {string} estado - The state of the user.
 * @param {string} municipio - The municipality of the user.
 * @param {boolean} isDefaultLocation - If is default location of the user.
 * @param {boolean} confirmLocation - If is confirmed location of the user.
 * @param {boolean} preventRedirect - If is prevent redirect to the page.
 * @returns {void} - The function does not return anything, but it sets the location of the user.
 * @throws {Error} - The error is thrown if the request fails.
 */
function setLocation(url, almacen, estado, municipio, isDefaultLocation, confirmLocation, preventRedirect) {
    if (!url) {
        return;
    }
    $.ajax({
        url: url,
        method: 'Get',
        data: {'almacen': almacen, 'estado': estado,'municipio': municipio},
        async: true,
        success: function (data) {
            if (data && data.sucursal && data.sucursal.length) {
                let selectedLocation = {
                    'ALMACEN_ID': almacen,
                    'ESTADO': estado,
                    'NOMBRE': municipio,
                    'CONFIRM_LOCATION': confirmLocation,
                    'DEFAULT': isDefaultLocation,
                    'SUCURSAL_ID': data.sucursal
                }
                document.cookie = 'dataUserObtenerMunicipios=' + encodeURIComponent(JSON.stringify(selectedLocation)) + '; expires=Wed, 1 Jan 2070 13:47:11 UTC; path=/';
                if (preventRedirect){
                    return;
                }
                // eslint-disable-next-line no-restricted-globals
                if (data.redirect) {
                    window.location.href = data.redirectUrl;
                } else {
                    window.location.reload(true);
                }
            }
            
        }
    });
}


let savedCookieLocation = geolocationHelper.getCookie('dataUserObtenerMunicipios');
if (savedCookieLocation.length === 0 || !savedCookieLocation) {
    setDefaultLocation();
} else {
    let locationInSession = $(".location-in-session").val();
    let data = JSON.parse(savedCookieLocation);
    let estado = data.ESTADO;
    let isGuatemala = estado.toLocaleLowerCase() === "guatemala";
    let selectorCountry = $(".selected-country strong");
    if (isGuatemala) {
        selectorCountry.text(estado);
    } else {
        selectorCountry.text(selectorCountry.data("default"));
    }

    // check if the cookie location is not set in the session
    if (!locationInSession || locationInSession === "undefined" || locationInSession === "null") {
        let municipio = data.NOMBRE;
        let almacen = data.ALMACEN_ID;

        // check if the page is previously reloaded by calling the setLocation function
        const pageAccessedByReload = sessionStorage.getItem("is_reloaded");

        if (almacen && !pageAccessedByReload) {
            var params = new URLSearchParams(window.location.search);
            if (!params.get('lostSession') || params.get('lostSession') !== 'true') {
                let url = $(".confirm-location").first().data("url");
                let isDefaultLocation = data.DEFAULT || false;
                let confirmLocation = data.CONFIRM_LOCATION || false;
                setLocation(url, almacen, estado, municipio, isDefaultLocation, confirmLocation);
                sessionStorage.setItem("is_reloaded", true);
            }            
        } else if (pageAccessedByReload) {
            sessionStorage.removeItem("is_reloaded");
        }
    }
}

/**
 * Get the location of the user.
 * @returns {void} - The function does not return anything, but it gets the location of the user.
 * @throws {Error} - The error is thrown if the request fails.
 */
function getLocationUser () {
    const opciones = {
        enableHighAccuracy: true,
        maximumAge: 30000,
        timeout: 27000
    };
    navigator.geolocation.getCurrentPosition(position => {
        if (!position || !position.coords || !position.coords.latitude || !position.coords.longitude) {
            return;
        }
        window.coord = 'latitud:' + position.coords.latitude + 'longitude: ' + position.coords.longitude
        document.cookie = 'coordenada='+window.coord +'; expires=Wed, 1 Jan 2070 13:47:11 UTC; path=/';
        $.ajax({
            url: window.geolocationUrl,
            type: 'POST',
            data: {data:JSON.stringify({latitud:position.coords.latitude,longitud:position.coords.longitude}),endpoint:'obtenmunicipios-post'},
            success:function(response) {
                if (!response.error && response.data && response.data.CIUDADES) {
                    response.data.CIUDADES[0].CONFIRM_LOCATION = false;
                    response.data.CIUDADES[0].GEOLOCATION = true;
                    document.cookie = 'dataUserObtenerMunicipios=' + encodeURIComponent(JSON.stringify(response.data.CIUDADES[0])) + '; expires=Wed, 1 Jan 2070 13:47:11 UTC; path=/';
                    window.location.reload(true);
                }
            }
        })
        
    }, e => {
        $.ajax({
            url: window.geolocationUrl,
            type: 'POST',
            data: {data:JSON.stringify({}),endpoint:'obtenmunicipios-post'},
            success:function(response) {
                if (!response.error && response.data && response.data.CIUDADES) {
                    response.data.CIUDADES[0].CONFIRM_LOCATION = false;
                    var cookieJSON ={
                        'ALMACEN_ID': response.data.CIUDADES[0].ALMACEN_ID,
                        'ESTADO': response.data.CIUDADES[0].ESTADO,
                        'NOMBRE': response.data.CIUDADES[0].NOMBRE,
                        'CONFIRM_LOCATION': false,
                        'DEFAULT': false,
                        'SUCURSAL_ID': response.data.CIUDADES[0].SUCURSAL_ID
                    }
                    document.cookie = 'dataUserObtenerMunicipios=' + encodeURIComponent(JSON.stringify(cookieJSON)) + '; expires=Wed, 1 Jan 2070 13:47:11 UTC; path=/';
                    window.location.reload(true);
                }
            }
        });
    },opciones);  
}

$( ".confirm-location" ).on( "click", function(e) {
    e.preventDefault();

    let url = $(this).data("url");
    let locationSection = $(this).parents(".location-section");
    let almacen = locationSection.find('.municipios').children(":selected").attr("id");
    let estado = locationSection.find('.entidadesFederativas').children(":selected").val();
    let municipio = locationSection.find('.municipios').children(":selected").text();

    setLocation(url, almacen, estado, municipio, false, true);
} );

/**
 * Get the states from the server.
 * @param {Object} $this - The object that contains the data attribute.
 * @returns {Object} - The data array of the states.
 * @throws {Error} - The error is thrown if the request fails.
*/
function getStates($this) {
    return $.ajax({
        url: $this.data('geolocation-manual-url'),
        method: 'Get',
        async: true,
        success: function (data) {
            return data;
        },
        // error handle
        error: function (error) {
            return error;
        }
    });
}

/**
 * Print the states in the dropdown.
 * @param {Object} data - The data array of the states.
 * @param {Object} selector - The selector of the dropdown.
 * @returns {void} - The function does not return anything, but it prints the states in the dropdown.
 */
function printEstados(data, selector) {
    const entidadesFederativas = JSON.parse(data.entidadesFederativas);
    selector.empty();
    $(".municipios").empty();
    let selectedLocation = geolocationHelper.getCookie('dataUserObtenerMunicipios');
    if(!(selectedLocation.length > 0)) {
        let defaultOption = '<option value="" selected>Escoge una opción</option>';
        $(defaultOption).appendTo(".municipios");
        $(defaultOption).appendTo(".entidadesFederativas");
    }
    $.each(entidadesFederativas, function (key, value) {
        $('<option id='+ value.ENTFEDNUM +'>' + value.NOMBRE + '</option>').appendTo(".entidadesFederativas");
    });
}

/**
 * Print the municipalities in the dropdown.
 * @param {string} estado - The state of the user.
 * @param {string} _url - The URL of the server.
 * @param {string} municipio - The municipality of the user.
 * @returns {void} - The function does not return anything, but it prints the municipalities in the dropdown.
 */
async function printMunicipalities(estado, _url, municipio) {
    await $.ajax({
        url: _url,
        method: 'Get',
        data: {'estado': estado},
        async: true,
        success: function (data) {
            $(".municipios").empty();
            let municipios = data.municipios;
            $.each(municipios, function (key, value) {
                $('<option id='+ value.almacenId +'>' + value.municipality + '</option>').appendTo(".municipios");
            });
            if (municipio) {
                var municipioInSelector = $(".municipios").find("option").filter(function () {
                    return this.text.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") == municipio.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                });
                municipioInSelector.prop('selected', true);
            }
        }
    });
}
/**
 * Check the selected location.
 * @param {string} selectedLocation - The selected location of the user cookie.
 * @returns {void} - The function does not return anything, but it fill selectors.
 */
async function checkSelectedLocation(selectedLocation) {
    let data = JSON.parse(selectedLocation);
    let estado = data.ESTADO;
    let municipio = data.NOMBRE;

    let estadoInSelector = $(".entidadesFederativas").find("option").filter(function () {
        return this.text.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "") == estado.toLocaleLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    });

    estadoInSelector.prop('selected', true);

    let estadoId = $(".entidadesFederativas").children(":selected").attr("id");

    printMunicipalities(estadoId, $(".entidadesFederativas").first().data('geolocation-municipios-url'), municipio);
}

$( ".add-location" ).on( "click", async function(event, isOpenedByDefault) {
    let locationSection = $(".location-con");
    let isLocationSectionVisible = locationSection.is(":visible") || locationSection.hasClass("d-block");
    if (isLocationSectionVisible && !isOpenedByDefault) {
        return;
    }
    let data = await getStates($(this));
    let selector = $(".entidadesFederativas");
    printEstados(data, selector);
    let selectedLocation = geolocationHelper.getCookie('dataUserObtenerMunicipios');
    
    if (selectedLocation.length > 0) {
        checkSelectedLocation(selectedLocation);
    }
    let screenWidht = $(window).width();
    if (screenWidht > 992) {
        $("#maincontent").animate({ marginTop: 310 }, "slow");
    }
    if (isOpenedByDefault) {
        $( ".location-con" ).show();
    } else {
        $( ".location-con" ).slideDown( "slow" );
    }
});

$('.entidadesFederativas').change(function() {
    var estado = $(this).children(":selected").attr("id");
    printMunicipalities(estado, $(this).data('geolocation-municipios-url'));
});

/**
 * Disable the checkout step.
 * @param {Object} isCart - The checkout button.
 *  @returns {void} - The function does not return anything, but it disables the checkout step.
 */
function disableCheckoutStep() {
    let btnCheckout = $(".checkout-btn");
    
    let pageWidth = $(window).width();
    if (pageWidth < 1200) {
        btnCheckout.attr("href", "#lineItemHeader");
    } else {
        btnCheckout.attr("href", "#");
    }
    
    btnCheckout.on("click", function() {
        if(window.fromButtonQuote) {
            return;
        }
        // update the subtitle label in checkout location components
        let cartMsg = $(".subtitle-label").data("cart-msg");
        let subtitleLabel = $(".subtitle-label");
        subtitleLabel.text(cartMsg);
        let modalSubtitle = $(".tablet-location-subtitle");
        modalSubtitle.text(cartMsg);

        // add opacity to the body
        $("#maincontent").addClass("custom-opacity");
        $("nav").addClass("custom-opacity");
        let isLocationSectionVisible = $(".location-con").is(":visible");
        let isBtnDisabled = btnCheckout.attr("href") === "#" || btnCheckout.attr("href") === "#lineItemHeader";
        
        // open location section if it is not visible and the button is disabled
        if(!isLocationSectionVisible && isBtnDisabled) {
            $(".add-location").trigger("click", false);
            $("#iconLocationTablet").trigger("click");
        }
        
        // if user permission is not granted and not denied then ask again for permission
        var isIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
        if (isIOS) {
            return;
        }
        navigator.permissions.query({name:'geolocation'}).then(function(result) {
            // Will return ['granted', 'prompt', 'denied']
            if (result.state !== "granted") {
                getLocationUser();
            }
        });
    });
}

$(document).ready(function () {
    const selectedLocationCookie = geolocationHelper.getCookie('dataUserObtenerMunicipios');
    const subMenuLocate = $(".submenu-locate");
    let isCart = $("#isCart").length > 0 ;
    var showLocationBar = $("#showLocationBar").length; // div#showLocationBar is only in pdp, plp and cart pages 

    // Update currentCGroup from cookie to avoid cached values from server (Page Designer cache issue)
    if (selectedLocationCookie.length > 0) {
        const locationData = JSON.parse(selectedLocationCookie);
        if (locationData && locationData.SUCURSAL_ID) {
            $('#currentCGroup').val(locationData.SUCURSAL_ID);
        }
    }

    // check if the location cookie is empty
    if (selectedLocationCookie.length === 0) {
        // show location bar if it is necessary
        subMenuLocate.removeClass("d-none");
        if (showLocationBar) {
            getLocationUser();
            $(".add-location").trigger("click", true);
            $("#iconLocationTablet").trigger("click");
        }
        // disable checkout step if is in cart
        if (isCart) {
            disableCheckoutStep();
        }
    } else {
        // fill the location bar with the selected location
        const selectedLocation = JSON.parse(selectedLocationCookie);
     
        let estado = selectedLocation.ESTADO;
        let municipio = selectedLocation.NOMBRE;
        let isGuatemala = estado.toLocaleLowerCase() === "guatemala";
        if (isGuatemala) {
            return;
        }
        subMenuLocate.removeClass("d-none");
        if (estado) {
            estado = estado.toLowerCase();
            estado = estado[0].toUpperCase() + estado.slice(1);
            municipio = municipio.toLowerCase();
            municipio = municipio[0].toUpperCase() + municipio.slice(1);

            const locationString = municipio + ', ' + estado;
            let isDefaultLocation = selectedLocation.DEFAULT;
            if (!isDefaultLocation || showLocationBar) {
                subMenuLocate.text(locationString);
            } 
        } 

        // show location bar if it isn't confirmed and showLocationBar is true (pdp, plp, cart)
        if (!selectedLocation.CONFIRM_LOCATION) {
            let isDefaultLocation = selectedLocation.DEFAULT;
            if (isDefaultLocation && showLocationBar) {
                getLocationUser();
            }
            if (showLocationBar && !selectedLocation.GEOLOCATION) {
                $(".add-location").trigger("click", true);
                $("#iconLocationTablet").trigger("click");
            } else {
                $(".location-con").hide();
            }
            if (isCart) {
                disableCheckoutStep();
            }
        } else {
            $(".location-con").hide();
        }
    }
});

// event to close the location section
$(document).on('click', '#closeLocationSection', function() {
    let screenWidht = $(window).width();
    if (screenWidht > 992) {
        $("#maincontent").animate({ marginTop: 190 }, "slow");
    }
    $(".location-con").slideUp({
        duration: "slow", 
        start: function () {
            $(this).removeClass("d-block");
            $("#maincontent").removeClass("custom-opacity");
            $("nav").removeClass("custom-opacity");
        }
    });
});

// event to show the location modal in tablet and mobile
$(document).on('click', '#iconLocationTablet', function() {
    (async () => {
        let pageWidth = $(window).width();
        if (pageWidth >= 992) {
            return;
        }

        let data = await getStates($(this));
        let selector = $(".entidadesFederativas");
        printEstados(data, selector);
        let selectedLocation = geolocationHelper.getCookie('dataUserObtenerMunicipios');
        if (selectedLocation.length > 0) {
            checkSelectedLocation(selectedLocation);
        }
        $('#location-modal').modal({backdrop: 'static', keyboard: false})  
        $('#location-modal').addClass('slide-from-bottom').appendTo("body").modal('show');
    })();
});
// Dynamic arrow dropdown
$(document).ready(function() {
    $('.dropcheck-geo').change(function() {
        if ($(this).is(':checked')) {
            $('.dropdown').addClass('expanded');
        } else {
            $('.dropdown').removeClass('expanded');
        }
    });
});

$(".redirect-to-country").on("click", function() {
    let dataCountry = $(this).data("country");
    let countryInSelector = $(".selected-country strong").text().normalize('NFD').replace(/[\u0300-\u036f]/g,"");
    let elementHref = $(this).attr("href");
    let urlSetlocation = $(".confirm-location").first().data("url");

    switch (dataCountry.toLowerCase()) {
        case "mexico":
            if (countryInSelector.toLocaleLowerCase() !== "mexico") {
                setDefaultLocation(true);
                window.location.href = elementHref && elementHref.length > 0 ? elementHref : $(".logo-home").attr("href");
            }
            break;
        case "guatemala":
            setLocation(urlSetlocation, "602VWGT", 'Guatemala', 'Guatemala', false, true, true);
            window.location.href = elementHref;
            break;
        default:
            if (elementHref) {window.open(elementHref, '_blank');}
            
    }
});

module.exports = {setLocation: setLocation};